import {FC} from 'react'

import cn from 'classnames/bind'

import PortableBlocks from 'components/blocks/PortableBlocks'
import {Col, Container, Row} from 'components/elements/grid'
import {Invoice} from 'src/types/__sanitySchema__'

import s from './InvoiceWhat.module.scss'
import LandingsTitle from '../../LandingsTitle/LandingsTitle'
const cx = cn.bind(s)

interface IInvoiceWhatProps {
	className?: string
	content: Invoice['what']
}

/** InvoiceWhat block component */
const InvoiceWhat: FC<IInvoiceWhatProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} />
				<Row>
					<Col xl={{span: 10, offset: 1}}>
						{content?.description && <PortableBlocks blockContent={content?.description} />}
					</Col>
				</Row>
			</Container>
		</div>
	)
}

InvoiceWhat.displayName = 'InvoiceWhat'

export default InvoiceWhat
